const initial_state = {
  prompt_text: "",
  is_from_start: true,
  current_step: "step_1",
  /*
  step_1 : gen_layer
  step_2 : gen_query
  step_3 : looping_query_list -> gen_message
  step_4 : gen_color -> gen_message
  */
  ai_preset_update_step: 0,
  ai_preset_update_layer: 0,
  ai_preset_update_fly: 0,
  layer_id_ai: [], //untuk satu user, untuk cek di edit layer
  active_layer_list: [], //yang sedang sudah di populate di chat dialog
  request_id: "",
  chat_list: [],
  layer_query_list: [],
  request_resume_status: "",
  current_progress_demo: 0,
  /*
  request_id,
  chat_list,
  layer_query_list: [
    {
      layer_id: {
        type: Schema.Types.ObjectId,
        ref: "manifests",
      },
      query_list: Array, //key, value_array
      style_object: {
        key: String,
        field_key: String,
        color_logic: String, //by_text, by_number_step, constant
        color_mode: String,
        value_array_base: Array,
        color_array_base: Array,
        color_array_ai: Array,
        style_type: String, //circle, line, fill
        constant_color: String,
        min: Number,
        max: Number,
        paint_object: Object,
      },
      fields: [
        {
          key: String,
          name: String,
          value_resume: Array, //yang sudah difilter
        },
      ],
    },
  ],
  */
};

export default function ai_preset_reducer(state = initial_state, action) {
  switch (action.type) {
    case "ai_preset_update_step":
      return {
        ...state,
        ai_preset_update_step: state.ai_preset_update_step + 1,
      };

    case "ai_preset_update_layer":
      return {
        ...state,
        ai_preset_update_layer: state.ai_preset_update_layer + 1,
      };

    case "ai_preset_update_fly":
      return {
        ...state,
        ai_preset_update_fly: state.ai_preset_update_fly + 1,
      };

    case "set_value_ai_preset":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case "push_value_layer_ai":
      return {
        ...state,
        [action.payload.key]: [
          ...state[action.payload.key],
          action.payload.value,
        ],
      };

    case "pull_value_layer_ai_string": {
      const list = state[action.payload.key].filter(
        (item) => item !== action.payload.value
      );
      return {
        ...state,
        [action.payload.key]: list,
      };
    }

    case "pull_value_layer_ai_object": {
      const list = state[action.payload.key].filter(
        (item) => item[action.payload.id] !== action.payload.value
      );
      return {
        ...state,
        [action.payload.key]: list,
      };
    }

    case "set_value_inside_array": {
      return {
        ...state,
        ...set_value_inside_array({
          list: state[action.payload.key_list],
          key_list: action.payload.key_list,
          layer_id: action.payload.layer_id,
          key: action.payload.key,
          value: action.payload.value,
        }),
      };
    }

    default:
      return state;
  }
}

const set_value_inside_array = (body) => {
  const { list, key_list, layer_id, key, value } = body;
  const index = list.findIndex((item) => item?.layer_id?._id === layer_id);
  if (index > -1) {
    list[index][key] = value;
  }
  return { [key_list]: list };
};
